import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import AppDialog from '../AppDialog';

export default function ManualAssignStorageUnit(props) {
    const {open, storageUnit, users, handleAssign, selectedUser, setSelectedUser, close} = props;

    // sort a copy — sorting `users` in place mutates the caller's state array
    const sortedUsers = useMemo(
        () => [...users].sort((a, b) => a.firstName.localeCompare(b.firstName)),
        [users]
    );

    function handleSelectedUserChange(event) {
        setSelectedUser(event.target.value);
    }

    return(
        <AppDialog
            open={open}
            onClose={close}
            title={`Manually Assign Storage Unit ${storageUnit?.name ?? ''}`}
            onSubmit={handleAssign}
            submitText='Save'
            submitDisabled={!selectedUser}
        >
            <FormControl fullWidth required>
                <InputLabel id='manual-assign-user-label'>User to Assign</InputLabel>
                <Select
                    labelId='manual-assign-user-label'
                    label='User to Assign'
                    value={users.some((user) => user.id === selectedUser) ? selectedUser : ''}
                    onChange={handleSelectedUserChange}
                >
                    {sortedUsers.map((user) =>
                        <MenuItem key={user.id} value={user.id}>
                            {`${user.firstName} ${user.lastName} (${user.username})`}
                        </MenuItem>
                    )}
                </Select>
            </FormControl>
        </AppDialog>
    );
}

ManualAssignStorageUnit.propTypes = {
    open: PropTypes.bool.isRequired,
    storageUnit: PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
    }),
    users: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number,
        firstName: PropTypes.string,
        lastName: PropTypes.string,
        username: PropTypes.string,
    })).isRequired,
    handleAssign: PropTypes.func.isRequired,
    /** the selected user's id, not the user object */
    selectedUser: PropTypes.number,
    setSelectedUser: PropTypes.func.isRequired,
    close: PropTypes.func.isRequired,
};